import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import DataTable from "react-data-table-component";
import Hdashboard from "../../../components/Hdashboard";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { AfterSchoolClassListApi, AfterSchoolClassLearnerListApi } from "../../../api/apiHandler";
import customStyles from "../../../utils/dataTableStyles";
import moment from "moment";

export default function AfterSchoolClassList({ isLoader }) {
    const location = useLocation();
    const navigate = useNavigate();
    const stateParams = location.state || {};

    const [classes, setClasses] = useState([]);
    const [learners, setLearners] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [view, setView] = useState("classes"); // "classes" | "learners"
    const [paginationOption, setPaginationOption] = useState(10);
    const [paginationOptions, setPaginationOptions] = useState([]);

    useEffect(() => {
        if (!stateParams.user_id) {
            navigate(-1);
            return;
        }
        fetchClasses();
    }, []);

    const buildPaginationOptions = (dataArr) => {
        const opts = [];
        for (let i = 10; i <= dataArr.length; i += 10) opts.push(i);
        if (dataArr.length <= 100) opts.push(dataArr.length);
        setPaginationOptions(opts);
    };

    const fetchClasses = () => {
        isLoader(true);
        AfterSchoolClassListApi({ user_id: stateParams.user_id })
            .then((response) => {
                if (response.code === "1") {
                    const withCount = response.data.map((row, idx) => ({ ...row, count: idx + 1 }));
                    setClasses(withCount);
                    buildPaginationOptions(withCount);
                } else {
                    setClasses([]);
                }
            })
            .catch(() => setClasses([]))
            .finally(() => isLoader(false));
    };

    const fetchLearners = (classRow) => {
        isLoader(true);
        AfterSchoolClassLearnerListApi({ class_id: classRow.class_id })
            .then((response) => {
                if (response.code === "1") {
                    const withCount = response.data.map((row, idx) => ({ ...row, count: idx + 1 }));
                    setLearners(withCount);
                    buildPaginationOptions(withCount);
                } else {
                    setLearners([]);
                }
                setSelectedClass(classRow);
                setView("learners");
            })
            .catch(() => {
                setLearners([]);
                setSelectedClass(classRow);
                setView("learners");
            })
            .finally(() => isLoader(false));
    };

    const handleBack = () => {
        if (view === "learners") {
            setView("classes");
            setSelectedClass(null);
            buildPaginationOptions(classes);
        } else {
            navigate(-1);
        }
    };

    const handlePaginationChange = (rowsPerPage) => {
        setPaginationOption(rowsPerPage);
    };

    const classColumns = [
        {
            name: "Sr. No",
            selector: (row) => row.count,
            sortable: false,
            width: "100px",
        },
        {
            name: "Class Name",
            selector: (row) => row.class_name,
            sortable: true,
            width: "300px",
        },
        {
            name: "Subject / Category",
            selector: (row) => row.subject_category,
            sortable: true,
            width: "250px",
        },
        {
            name: "No. of Learners",
            selector: (row) => row.total_learners,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div
                    className="text-primary"
                    style={{ cursor: "pointer", textDecoration: "underline", fontWeight: "600" }}
                    onClick={() => fetchLearners(row)}
                >
                    {row.total_learners}
                </div>
            ),
        },
        {
            name: "Created On",
            selector: (row) => row.created_at,
            sortable: true,
            width: "200px",
            cell: (row) => moment(row.created_at).format("YYYY-MM-DD HH:mm:ss"),
        },
    ];

    const learnerColumns = [
        {
            name: "Sr. No",
            selector: (row) => row.count,
            sortable: false,
            width: "100px",
        },
        {
            name: "Profile",
            selector: (row) => row.profile_image,
            sortable: false,
            width: "150px",
            cell: (row) => (
                <div className="d-flex my-2">
                    <img
                        className="imageTable_rounded"
                        src={row.profile_image}
                        alt="profile"
                        style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%" }}
                    />
                </div>
            ),
        },
        {
            name: "Name",
            selector: (row) => row.full_name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            width: "300px",
        },
        {
            name: "Country",
            selector: (row) => row.country_name,
            sortable: true,
            width: "200px",
        },
        {
            name: "Registered On",
            selector: (row) => row.created_at,
            sortable: true,
            width: "200px",
            cell: (row) => moment(row.created_at).format("YYYY-MM-DD HH:mm:ss"),
        },
    ];

    const title = view === "classes"
        ? `Classes of ${stateParams.user_name || "After School User"}`
        : `Learners in "${selectedClass?.class_name || "Class"}"`;

    const activeData = view === "classes" ? classes : learners;
    const activeColumns = view === "classes" ? classColumns : learnerColumns;

    return (
        <>
            <JqueryLoad />
            <Hdashboard />
            <header className="dashboard-toolbar d-lg-flex justify-content-between">
                <div className="align-items-center justify-content-between d-flex">
                    <div className="d-flex align-items-center">
                        <a className="menu-toggle align-items-center d-lg-none d-flex">
                            <i className="fa fa-bars" />
                        </a>
                        <a href="index.php" className="d-lg-none d-block brand-logo">
                            <img src="./assets/images/logo.png" alt="logo" />
                        </a>
                    </div>
                </div>
            </header>

            <section className="main_sec">
                <div className="mt-4 mx-5">
                    <div>
                        <span onClick={handleBack} style={{ cursor: "pointer" }}>
                            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" />
                            </svg>
                            <span className="ms-2">Back</span>
                        </span>
                    </div>
                    <p className="fs-4 fw-500 text-center mb-5">{title}</p>

                    <div className="mt-4">
                        {activeData && activeData.length > 0 ? (
                            <DataTable
                                columns={activeColumns}
                                data={activeData}
                                pagination
                                paginationPerPage={paginationOption}
                                onChangeRowsPerPage={handlePaginationChange}
                                paginationRowsPerPageOptions={paginationOptions}
                                customStyles={customStyles}
                            />
                        ) : (
                            <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
